exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tippy-tooltip.default-theme{font-size:.875rem!important;font-weight:400!important;text-align:center!important;background-color:#fff!important}.tippy-title{font-weight:700!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-003cf456","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./resources/js/components/CompaniesList.vue
// module id = gfN+
// module chunks = 0 1